var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDividerCapAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16v-3h10v-2H11V8l-4 4 4 4zm-8 4h2V4H3v16zM36.378 7.73v3h-10v2h10v3l4-4-4-4zm8-4h-2v16h2v-16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerCapAll);
export default __webpack_public_path__ + "static/media/divider_cap_all.afb69b7ae0fcc3d8a5c3bf2feaeaa44a.svg";
export { ForwardRef as ReactComponent };